import isNil from 'lodash/fp/isNil';

import type { ApiCustomerPoi, ApiPoi, ApiWorkshopPoi } from '../apiTypes';
import { type PoiAddress, type PoiDetails, PoiTypes } from '../types';

export const mapPoiDetails = (poi: ApiPoi): PoiDetails => {
    switch (poi.type) {
        case PoiTypes.customer: {
            const customerPoi = poi as ApiCustomerPoi;
            return {
                id: customerPoi.id,
                name: customerPoi.name,
                type: customerPoi.type,
                coordinates: customerPoi.coordinates,
                address: customerPoi.address ?? undefined,
                category: customerPoi.category,
            };
        }
        case PoiTypes.workshop: {
            const workshopPoiDto = poi as ApiWorkshopPoi;
            return {
                id: workshopPoiDto.id,
                name: workshopPoiDto.name ?? undefined,
                type: workshopPoiDto.type,
                coordinates: workshopPoiDto.coordinates,
                address: mapAddress(workshopPoiDto.address),
                contact: workshopPoiDto.contact,
            };
        }
    }
};

const mapAddress = (address?: PoiAddress): string | undefined => {
    if (isNil(address) || isNil(address.zip) || isNil(address.street) || isNil(address.city)) {
        return;
    }
    return `${address.street}, ${address.zip} ${address.city} ${address.country}`;
};
